import { render, staticRenderFns } from "./app.vue?vue&type=template&id=d71fec12&scoped=true"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"
import style0 from "./app.vue?vue&type=style&index=0&id=d71fec12&scoped=true&lang=scss"
import style1 from "./app.vue?vue&type=style&index=1&id=d71fec12&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71fec12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d71fec12')) {
      api.createRecord('d71fec12', component.options)
    } else {
      api.reload('d71fec12', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=d71fec12&scoped=true", function () {
      api.rerender('d71fec12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serve/app.vue"
export default component.exports